import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function UsingSmsAuth () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' },
    { name: 'Using SMS Authentication', href: '/login-help/using-sms-auth' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Multifactor Authentication - Using SMS Authentication</h2>

      <Card>
        <CardBody>
          <p>
            Tap the <b>Send Code</b> button.
            On your mobile device, you will receive a text message containing a verification code.
            Enter the code, then tap <b>Verify</b> to complete the authentication process.
          </p>
          <img className='mb-4' src='/static/img/using-sms-auth.png' alt='using sms authentication' />
        </CardBody>
      </Card>
    </>
  )
}

UsingSmsAuth.publicAccess = true

UsingSmsAuth.getInitialProps = () => ({
  title: 'MFA Using SMS'
})

export default UsingSmsAuth
